import React, { Component } from "react";
import { Card, Row, Col, Button, Form } from "react-bootstrap";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import DataTable from "react-data-table-component";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { connect } from "react-redux";
import { SuperAdminAction, EnforcementActions } from "../../Actions";
import Loader from "../Loader/Loader";
import CustomContentAlert, {
  tableHeightScrollBarsTab,
  findBySearch,
  utcToSpecificTimeZone,
  scroolToTop,
} from "../helper";
import isEqual from "lodash/isEqual";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropertDetails from "../LandingPage/PropertySelection";
import moment from "moment";
import { saveAs } from "file-saver";
const moment_timezone = require("moment-timezone");

class RevenueSummaryReport extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.state = {
      PropertyId: this.props.PropertyId,
      ticketList: [],
      ticketSummary: [],
      loader: false,
      user_type: this.props.user_type,
      suite_id: this.props.suite_id,
      confirmRemoveResidence: false,
      confirmRemoveResidenceData: null,
      uuid: "",
      searchValue: "",
      prevSearch: "",
      prevPage: "",
      prevNorow: "",
      // ticketList: [],
      api_response: false,
      show_alert: false,
      show_alert_on_remove_resident: false,
      show_error_on_remove_resident: false,
      api_success_message: "",
      api_error_message: "",
      page: 1,
      Norow: 100,
      selectedColumn: "created_at",
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      findMore: false,
      count: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      showModal: false,
      isFormValid: true,
      status: "",
      remark: "",
      validStatus: true,
      validRemark: true,
      show: false,
      showTicketDetails: false,
      ticketDetails: {},
      state: "",
      ticketPdfUrl: "",
      isSendMailModalOpen: false,
      emailToSend: "",
      isMailFormValid: false,
      selectedTicketId: "",
      isMailModal: false,
      selectedProperty: "",
      selectedPropertyObj: {},
      all_proparties: [],
      childcheckbox: true,
      ticketReportLots: [],
      lot_id: "",
      currentLOT: [],
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentDate: "",
      detailedDate: null,
      month: "",
      year: "",
      selectedRadio: "",
      activeTab: "1",
      currentSummaryDate: "",
      summaryMonth: "",
      lotsSummary: [],
      apiResponse: "",
      dateRanges: [
        {
          startDate: new Date(),
          endDate: null,
          key: "selection",
        },
      ],
      exportLink: false,
      exportButtonDisable: true,
      daysDifference: 30,
      //  newColumn: [],
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };
    this.columns = [
      {
        name: "Meter",
        width: "180px",
        sortable: true,
        cell: (row) => <div>{row.Agent ? row.Agent : "-"}</div>,
        selector: (row) => row.Agent,
      },
      {
        name: "Location",
        sortable: true,
        width: "180px",
        cell: (row) => <div>{row.Location ? row.Location : "-"}</div>,
        selector: (row) => row.Location,
      },
      {
        name: "Total $",
        sortable: true,
        // width: "160px",
        cell: (row) => (
          <div>
            {row.TotalAmount
              ? `$${parseFloat(row.TotalAmount).toFixed(2)}`
              : "-"}
          </div>
        ),
        selector: (row) => row.TotalAmount,
      },
      {
        name: "Total #",
        sortable: true,
        // width: "160px",
        cell: (row) => <div> {row.TotalTicket ? row.TotalTicket : "-"}</div>,
        selector: (row) => row.TotalTicket,
      },
      {
        name: "Cash $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.CashAmount).toFixed(2)}</div>,
        selector: (row) => row.CashAmount,
      },
      {
        name: "Cash #",
        sortable: true,
        cell: (row) => <div>{row.CashCount}</div>,
        selector: (row) => row.CashCount,
      },
      {
        name: "Interac Debit $",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>${parseFloat(row.InteracAmount).toFixed(2)}</div>,
        selector: (row) => row.InteracAmount,
      },
      {
        name: "Interac Debit #",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>{row.InteracCount}</div>,
        selector: (row) => row.InteracCount,
      },
      {
        name: "Master Card $",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>${parseFloat(row.MasterAmount).toFixed(2)}</div>,
        selector: (row) => row.MasterAmount,
      },
      {
        name: "Master Card #",
        sortable: true,
        minWidth: "130px",
        //  width: "140px",
        cell: (row) => <div>{row.MasterCount}</div>,
        selector: (row) => row.MasterCount,
      },
      {
        name: "Visa $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.VisaAmount).toFixed(2)}</div>,
        selector: (row) => row.VisaAmount,
      },
      {
        name: "Visa #",
        sortable: true,
        cell: (row) => <div>{row.VisaCount}</div>,
        selector: (row) => row.VisaCount,
      },
      {
        name: "Other $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.OtherAmount).toFixed(2)}</div>,
        selector: (row) => row.OtherAmount,
      },
      {
        name: "Other #",
        sortable: true,
        cell: (row) => <div>{row.OtherCount}</div>,
        selector: (row) => row.OtherCount,
      },
    ];

    this.newColumns = [
      {
        name: "Meter",
        sortable: true,
        width: "160px",
        cell: (row) => <div>{row.Agent ? row.Agent : "-"}</div>,
        selector: (row) => row.Agent,
      },
      {
        name: "Location",
        sortable: true,
        width: "180px",
        cell: (row) => <div>{row.Location ? row.Location : "-"}</div>,
        selector: (row) => row.Location,
      },
      {
        name: "Transaction Time",
        sortable: true,
        width: "160px",
        cell: (row) => (
          <div>
            {row.transaction_time
              ? utcToSpecificTimeZone(this.props.timezone, row.transaction_time)
              : "-"}
          </div>
        ),
        selector: (row) => row.transaction_time,
      },
      {
        name: "Total $",
        sortable: true,
        // width: "160px",
        cell: (row) => (
          <div>
            {row.TotalAmount
              ? `$${parseFloat(row.TotalAmount).toFixed(2)}`
              : "-"}
          </div>
        ),
        selector: (row) => row.TotalAmount,
      },
      {
        name: "Total #",
        sortable: true,
        // width: "160px",
        cell: (row) => <div> {row.TotalTicket ? row.TotalTicket : "-"}</div>,
        selector: (row) => row.TotalTicket,
      },
      {
        name: "Cash $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.CashAmount).toFixed(2)}</div>,
        selector: (row) => row.CashAmount,
      },
      {
        name: "Cash #",
        sortable: true,
        cell: (row) => <div>{row.CashCount}</div>,
        selector: (row) => row.CashCount,
      },
      {
        name: "Interac Debit $",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>${parseFloat(row.InteracAmount).toFixed(2)}</div>,
        selector: (row) => row.InteracAmount,
      },
      {
        name: "Interac Debit #",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>{row.InteracCount}</div>,
        selector: (row) => row.InteracCount,
      },
      {
        name: "Master Card $",
        sortable: true,
        minWidth: "130px",
        cell: (row) => <div>${parseFloat(row.MasterAmount).toFixed(2)}</div>,
        selector: (row) => row.MasterAmount,
      },
      {
        name: "Master Card #",
        sortable: true,
        minWidth: "130px",
        //  width: "140px",
        cell: (row) => <div>{row.MasterCount}</div>,
        selector: (row) => row.MasterCount,
      },
      {
        name: "Visa $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.VisaAmount).toFixed(2)}</div>,
        selector: (row) => row.VisaAmount,
      },
      {
        name: "Visa #",
        sortable: true,
        cell: (row) => <div>{row.VisaCount}</div>,
        selector: (row) => row.VisaCount,
      },
      {
        name: "Other $",
        sortable: true,
        cell: (row) => <div>${parseFloat(row.OtherAmount).toFixed(2)}</div>,
        selector: (row) => row.OtherAmount,
      },
      {
        name: "Other #",
        sortable: true,
        cell: (row) => <div>{row.OtherCount}</div>,
        selector: (row) => row.OtherCount,
      },
    ];
  }

  changeProperty(event) {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.setState(
      {
        selectedProperty: event.value,
        selectedPropertyObj: event,
        startDate: new Date(datebeforeThirtyDays),
        endDate: new Date(),
        month: null,
        year: null,
        currentDate: null,
        selectedRadio: null,
      },
      () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.selectedProperty
        );
        const selectedPropertyName = selectedPropertyObj
          ? selectedPropertyObj.site_name
          : "";
        const selectedDomainName = selectedPropertyObj
          ? selectedPropertyObj.domain
          : "";

        this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
        this.props.selected_Property(selectedPropertyObj);
        this.props.get_all_lots(event.value);
        const current_lot = this.props.lots;
        this.setState({
          ticketReportLots: current_lot,
        });
        this.setState({
          isFormValid: true,
          pageDropdownDisabled: false,
        });
      }
    );
  }

  handleCheckBox = () => {
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  componentDidMount = async () => {
    await this.getTickets();
    await this.props.get_all_properties();
    const { PropertyId } = this.state;
    await this.props.get_all_lots(PropertyId);
    const current_lot = this.props.lots;
    this.setState(
      {
        api_response: this.props?.api_response,
        all_properties: this.props?.getAllProperties,
        ticketReportLots: current_lot,
      },
      async () => {
        const selectedPropertyObj = this.state.all_properties.find(
          (item) => item.id === PropertyId
        );
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
          });
        }
      }
    );

    const exportUrl = `${process.env.REACT_APP_CONFIG_BASE_URL}`;
    if (exportUrl) {
      this.setState({
        exportUrl: `${exportUrl}/api/v1/revenue_report/export/${this.state?.property?.id}`,
        exportPdfUrl: `${exportUrl}/api/v1/revenue_report/exportPdf`,
      });
    }
    const height = tableHeightScrollBarsTab();
    this.setState({
      finalTableHeight: height,
    });
  };

  getTickets = async () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        childcheckbox,
        timezone,
        startDate,
        endDate,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        timezone,
        childcheckbox,
      };
      if (startDate) {
        pageobj.startDate = startDate;
      }
      if (endDate) {
        pageobj.endDate = endDate;
      }
      await this.props.getRevenueSummary(pageobj);
      const selectedPropertyName = this.state.property?.property_name;
      const selectedDomainName = this.state.property?.domain;
      await this.props.setDomainHeader(
        selectedPropertyName,
        selectedDomainName
      );
      this.setState({
        ticketList:
          this.props.ticketList &&
          this.props.ticketList.rows &&
          this.props.ticketList.rows.length
            ? JSON.parse(JSON.stringify(this.props.ticketList.rows))
            : [],
        api_response: this.props.api_response,
        count: this.props.ticketList.count,
      });
      this.setState({ loader: false });
    });
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.ticketList, this.props.ticketList)) {
      this.setState({
        ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        // ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        pageChanged: true,
        count: this.props.ticketList.count,
      });
    }
    if (!isEqual(prevProps.lots, this.props.lots)) {
      this.setState({
        ticketReportLots: this.props.lots,
        lotsSummary: this.props.lots,
      });
    }
  };

  dataTableHandle = (ticketList) => {
    return (
      <DataTable
        data={
          this.state.searchValue.length
            ? this.state.searchedticketList
            : ticketList
        }
        columns={this.state.detailedDate ? this.newColumns : this.columns}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        onChangePage={scroolToTop}
        fixedHeader={true}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={this.state.Norow}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  handleChangeLot = ({ target }) => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.setState({
      [target.name]: target.value,
      month: null,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      year: null,
      currentDate: null,
      selectedRadio: null,
    });
  };

  handleCurrentDate = (date) => {
    this.setState({
      currentDate: date,
      month: null,
      year: null,
      startDate: null,
      endDate: null,
      selectedRadio: null,
      detailedDate: null,
    });
  };

  handleCurrentDetailedDate = (date) => {
    this.setState({
      detailedDate: date,
      currentDate: null,
      month: null,
      year: null,
      startDate: null,
      endDate: null,
      selectedRadio: null,
    });
  };

  handleChangeStartingDates = (date) => {
    this.setState({
      startDate: date,
      month: null,
      year: null,
      currentDate: null,
      selectedRadio: null,
      detailedDate: null,
    });
  };

  handleChangeEndDates = (date) => {
    this.setState({
      endDate: date,
      month: null,
      year: null,
      currentDate: null,
      selectedRadio: null,
      detailedDate: null,
    });
  };

  handleSearch = () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        lot_id,
        childcheckbox,
        month,
        year,
        currentDate,
        startDate,
        endDate,
        selectedRadio,
        selectedPropertyObj,
        PropertyId,
        exportLink,
        detailedDate,
        timezone,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        childcheckbox,
        PropertyId,
        timezone,
        exportLink,
      };
      if (Object.keys(selectedPropertyObj).length) {
        pageobj.PropertyId = selectedPropertyObj.value;
      } else {
        pageobj.PropertyId = PropertyId;
      }
      if (lot_id) {
        pageobj.lot_id = lot_id;
      }
      if (selectedRadio) {
        pageobj.selectedRadio = selectedRadio;
      }
      if (currentDate) {
        pageobj.currentDate = currentDate;
      }
      if (detailedDate) {
        pageobj.detailedDate = detailedDate;
      }
      if (month) {
        pageobj.month = month;
      }
      if (year) {
        pageobj.year = moment_timezone(year).format("YYYY");
      }
      if (startDate && endDate) {
        pageobj.startDate = startDate;
        pageobj.endDate = endDate;
      }
      await this.props.getRevenueSummary(pageobj);
      this.setState({
        ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        api_response: this.props.api_response,
        count: this.props.ticketList.count,
        exportButtonDisable: false,
      });
      this.setState({ loader: false });
      document.body.classList.remove("foc-open");
    });
  };

  handleSearchChange = async ({ target }) => {
    this.setState({ searchValue: target.value }, async () => {
      const columnList = [
        "Agent",
        "Location",
        "TotalAmount",
        "TotalTicket",
        "CashAmount",
        "CashCount",
        "InteracAmount",
        "InteracCount",
        "MasterAmount",
        "MasterCount",
        "VisaAmount",
        "VisaCount",
        "OtherAmount",
        "OtherCount",
        "transaction_time",
      ];
      if (this.state.searchValue.length) {
        if (!this.state.findMore) {
          this.setState(
            {
              searchedticketList: findBySearch(
                this.state.searchValue,
                this.state.ticketList,
                this.state.ticketList,
                columnList,
                this.props.timezone
              ),
            },
            () => {
              this.setState({ count: this.state.searchedticketList.length });
            }
          );
        }
      } else {
        this.setState({
          count: this.props.ticketList.count,
          searchedticketList: [],
          ticketList: this.props.ticketList.rows,
        });
      }
    });
  };

  resetAll = async () => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(
      today.getDate() - this.state.daysDifference
    );
    this.setState({
      selectedRadio: null,
      month: null,
      year: null,
      currentDate: null,
      selectedPropertyObj: {},
      lot_id: "",
      childcheckbox: true,
      exportButtonDisable: true,
      detailedDate: null,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
    });
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      exportLink,
      selectedDomainName,
      timezone,
      startDate,
      endDate,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      exportLink,
      timezone,
    };
    if (startDate) {
      pageobj.startDate = new Date(datebeforeThirtyDays);
    }
    if (endDate) {
      pageobj.endDate = new Date();
    }
    await this.props.getRevenueSummary(pageobj);
    this.setState({
      pageChanged: true,
      page: 1,
      ticketList: this.props.ticketList.rows,
      count: this.props.ticketList.count,
      selectedPropertyObj: {
        label: selectedDomainName,
        value: PropertyId,
      },
    });
    setTimeout(() => {
      this.setState({ findMore: false });
    }, 2000);
    this.setState({ loader: false });
    document.body.classList.remove("foc-open");
  };

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleExport = async () => {
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      lot_id,
      childcheckbox,
      month,
      year,
      currentDate,
      startDate,
      endDate,
      selectedRadio,
      selectedPropertyObj,
      PropertyId,
      selectedDomainName,
      timezone,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      childcheckbox,
      PropertyId,
      timezone,
      exportData: true,
    };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    if (lot_id) {
      pageobj.lot_id = lot_id;
    }
    if (selectedRadio) {
      pageobj.selectedRadio = selectedRadio;
    }
    if (currentDate) {
      pageobj.currentDate = currentDate;
    }
    if (month) {
      pageobj.month = month;
    }
    if (year) {
      pageobj.year = moment_timezone(year).format("YYYY");
    }
    if (startDate && endDate) {
      pageobj.startDate = startDate;
      pageobj.endDate = endDate;
    }

    const bufferData = await this.props.getRevenueSummary(pageobj);
    const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
    const exportDataName = `REVENUE-SUMMARY-${currentTimeDate}-${selectedDomainName}.xls`;
    if (bufferData) {
      saveAs(
        new Blob([bufferData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        exportDataName
      );
    }
  };

  render() {
    const {
      ticketList,
      loader,
      childcheckbox,
      ticketReportLots,
      lot_id,
      startDate,
      endDate,
      currentDate,
      searchValue,
      detailedDate,
      //  month,
      //  year,
    } = this.state;

    return (
      <div>
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <div className="sidebarFilter">
                <Card className="contact-container mb-0">
                  <Card.Header
                    style={{ backgroundColor: this.props.main_body }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h4">Revenue Summary Report</Card.Title>
                      <a
                        onClick={this.hideSlider}
                        href="javascript:void(0);"
                        className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="12">
                        <div className="mb-2">
                          <label className="fancy-checkbox">
                            <input
                              type="checkbox"
                              name={"childcheckbox"}
                              checked={childcheckbox}
                              onChange={this.handleCheckBox}
                              className="custom-control-input"
                              id="childcheckbox1"
                            ></input>
                            <span>
                              <i></i>Include Children Sites
                            </span>
                          </label>
                        </div>
                      </Col>
                      <Col md="12">
                        <PropertDetails
                          selectedPropertyObj={this.state.selectedPropertyObj}
                          changeProperty={this.changeProperty.bind(this)}
                        />
                      </Col>
                      <Col md="12">
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label>LOTS:</Form.Label>
                          <Form.Control
                            as="select"
                            name="lot_id"
                            value={lot_id}
                            onChange={this.handleChangeLot}
                            disabled={ticketReportLots.length < 1}
                            placeholder="Select Lot"
                          >
                            {ticketReportLots && ticketReportLots.length ? (
                              <>
                                <option value="">Any</option>
                                {ticketReportLots.map((item, index) => (
                                  <option key={index} value={item.id}>
                                    {item.alias}
                                  </option>
                                ))}
                              </>
                            ) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      {/* <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">MONTH:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Month"
                            selected={month}
                            value={month}
                            disabled={loader}
                            onChange={this.handleMonth}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">YEAR:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Year"
                            selected={year}
                            defaultHour={24}
                            value={year}
                            disabled={loader}
                            onChange={this.handleYear}
                            showYearPicker
                            dateFormat="yyyy"
                          />
                        </Form.Group>
                      </Col> */}
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Date"
                            selected={currentDate}
                            value={currentDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleCurrentDate}
                            dateFormat="MM/dd/yyyy"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">DETAILED:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select End Date"
                            selected={detailedDate}
                            disabled={loader}
                            value={detailedDate}
                            selectsEnd
                            timeInputLabel="Time:"
                            onChange={this.handleCurrentDetailedDate}
                            dateFormat="MM/dd/yyyy"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">START DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Start Date"
                            selected={startDate}
                            defaultHour={24}
                            value={startDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleChangeStartingDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            maxDate={new Date()}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">END DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select End Date"
                            selected={endDate}
                            disabled={loader}
                            value={endDate}
                            selectsEnd
                            timeInputLabel="Time:"
                            onChange={this.handleChangeEndDates}
                            // dateFormat="MM/dd/yyyy hh:mm:ss aa"
                            dateFormat="MM/dd/yyyy"
                            // showTimeInput
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            maxDate={endDate}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="text-right justify-content-between d-flex">
                    <Button
                      variant="info"
                      className="h-40 custom-btn-secondary btn-sm"
                      onClick={this.resetAll}
                      disabled={loader}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="info"
                      className="h-40 btn-fill btn-sm ml-2"
                      onClick={this.handleSearch}
                      disabled={loader}
                    >
                      Search
                    </Button>
                  </Card.Footer>
                </Card>
              </div>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0">Revenue Summary</h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                      <DatatableHeader
                        className="mt-0 mb-0"
                        searchValue={searchValue}
                        HandleChange={this.handleSearchChange}
                        // findMorePressed={this.findMorePressed}
                      />
                    </div>
                    <div className="ml-2">
                      <Button
                        variant="info"
                        className="btn-fill btn-sm"
                        onClick={this.handleExport}
                        disabled={ticketList.length > 0 ? 0 : 1}
                        size="medium"
                      >
                        Export
                      </Button>
                    </div>
                  </div>
                </div>
              </header>
            </>
            {loader ? (
              <Loader />
            ) : (
              <>
                {this.state.show_alert && (
                  <CustomContentAlert
                    delay={2000}
                    message={this.state.api_success_message}
                    className="toast-success"
                  />
                )}
                {ticketList && (
                  <>
                    <div className="citation-list-table list-of-ravenue-table">
                      {this.dataTableHandle(ticketList)}
                    </div>
                  </>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  SuperAdminDetails,
  CurrentPermitDetails,
  EnforcementDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const {
    property_id: PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
  } = UserProfileDetails;
  const {
    revenueSummaryList: ticketList, // citationSummaryList: ticketSummary
  } = EnforcementDetails;
  const { backgroundColor } = Logindetails;
  const { residentList } = CurrentPermitDetails;
  const { getAllProperties, lots } = SuperAdminDetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
    ticketList,
    main_body,
    getAllProperties,
    residentList,
    lots,
    //  ticketSummary,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
  getRevenueSummary: EnforcementActions.getRevenueSummary,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  get_all_lots: SuperAdminAction.get_all_lots,
  // getCitationIssuedSummary: EnforcementActions.getCitationIssuedSummary,
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(RevenueSummaryReport);
